import { resolveThoughtSummaryWithDuration } from '@/services/chatApi'

/** @param {import('./runApiCompletionStream.js').ApiCompletionCtx} ctx */
export function applyApiBlocksOnlyResult(ctx, blocksFromApi, assistantMeta) {
  const { tid, pendingId, session, setMessagesByThreadId } = ctx
  setMessagesByThreadId((inner) => {
    const list = [...(inner[tid] ?? [])]
    const idx = list.findIndex((m) => m.id === pendingId)
    if (idx === -1) return inner
    const next = [...list]
    const prev = list[idx]
    next[idx] = {
      ...next[idx],
      text: '',
      blocks: blocksFromApi,
      createdAt: Date.now(),
      ...assistantMeta,
      thoughtSummary: resolveThoughtSummaryWithDuration(prev, assistantMeta),
    }
    return { ...inner, [tid]: next }
  })
  session.dispose()
}
